'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {

	var apiUrl = apiConfig.$get().apiUrl;
	
	return {
		error: function(msg) {
			growl(msg.data.error, 1);
		},
		location: $resource(
					apiUrl + '/warehouse/location/:location_id',
					{
						supplier_company_id:'@supplier_company_id',
						location_id:'@location_id'
					}, 
					{
						query: {
							isArray: true,
						},
						create: {
							method: 'POST',
							data: '@location'
						}, 
						update: {
							method: 'PUT',
							data: '@location'
						}, 
						delete: {
							method: 'DELETE'
						}
					}
				),
		warehouse: $resource(
					apiUrl + '/warehouse/:warehouse_id',
					{
						location_id:'@location_id',
						warehouse_id:'@warehouse_id'
					}, 
					{
						query: {
							isArray: true,
						},
						create: {
							method: 'POST',
							data: '@warehouse'
						}, 
						update: {
							method: 'PUT',
							data: '@warehouse'
						}, 
						delete: {
							method: 'DELETE'
						}
					}
				),
		storageplace: $resource(
					apiUrl + '/warehouse/storageplace/:storageplace_id',
					{
						storageplace_id:'@storageplace_id',
						warehouse_id:'@warehouse_id',
					}, 
					{
						query: {
							isArray: true,
						},
						create: {
							method: 'POST',
							data: '@storageplace'
						}, 
						update: {
							method: 'PUT',
							data: '@storageplace'
						}, 
						delete: {
							method: 'DELETE'
						}
					}
				)

	};
}
